export default __webpack_public_path__ + "static/media/Diferenciais.dbfc8d37.png";